import React from "react";
import DayList from "./DayList";
import Appointment from "components/Appointment";
import {
	getAppointmentsForDay,
	getInterview,
	getInterviewersForDay,
} from "helpers/selectors";
import "components/Application.scss";
import useApplicationData from "hooks/useApplicationData";

export default function Application(props) {
	const { state, setDay, bookInterview, cancelInterview } = useApplicationData();

	// array of interviewers on specific day
	const interviewers = getInterviewersForDay(state, state.day);

	// use helper function to transform data that needs to pass down to Appointment component (getAppointmentsForDay)
	const appointments = getAppointmentsForDay(state, state.day).map(appointment => {
		return (
			<Appointment
				key={appointment.id}
				{...appointment}
				interview={getInterview(state, appointment.interview)}
				interviewers={interviewers}
				bookInterview={bookInterview}
				cancelInterview={cancelInterview}
			/>
		);
	});

	return (
		<main className="layout">
			<section className="sidebar">
				<img
					className="sidebar--centered"
					src="images/logo.png"
					alt="Interview Scheduler"
				/>
				<hr className="sidebar__separator sidebar--centered" />
				<nav className="sidebar__menu">
					<DayList days={state.days} value={state.day} onChange={setDay} />
				</nav>
				<img
					className="sidebar__lhl sidebar--centered"
					src="images/lhl.png"
					alt="Lighthouse Labs"
				/>
			</section>
			<section className="schedule">
				{appointments}
				<Appointment key="last" time="5pm" />
			</section>
		</main>
	);
}
